import { render, staticRenderFns } from "./plmItem.vue?vue&type=template&id=06195fb8&scoped=true"
import script from "./plmItem.vue?vue&type=script&lang=js"
export * from "./plmItem.vue?vue&type=script&lang=js"
import style0 from "./plmItem.vue?vue&type=style&index=0&id=06195fb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06195fb8",
  null
  
)

export default component.exports